import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Input, Select } from '../../../../components/ModalInputs'
import { OrderContext } from '../../../../utils/context'
import moment from 'moment'
import { getCLasses, getCourses } from '../../../../actions/common'
import Button from '../../../../components/Button'
import EnrollModal from '../EnrollModal/EnrollModal'
import Table from '../../../../components/Table'


export default function EncouragingStudents() {

  const dispatch = useDispatch()

  const { values, handleChange, setValues } = useContext(OrderContext)
  const { list } = useSelector(state => state.students)
  const { studentList } = list || {}

  const [openEnrollModal, setOpenEnrollModal] = useState(false)
  const [selectedStudents, setSelectedStudents] = useState([])

  useEffect(() => {
    !list && dispatch(getCourses())
    const profilesIn = values.profiles && values.profiles.map(el => list.find(item => item.mid == el))
    profilesIn && setSelectedStudents(profilesIn)
  }, [list])

  useEffect(() => {
    const onlyId = selectedStudents && selectedStudents.map(el => el.mid)
    !!selectedStudents && setValues({ ...values, profiles: onlyId })
  }, [selectedStudents])


  const openEnroll = () => {
    setOpenEnrollModal(true)
  }
  const closeEnroll = () => {
    setOpenEnrollModal(false)
  }

  const handleChangeStudents = (student) => {
    if (typeof student === 'number') setSelectedStudents((prev) => prev.filter(el => el.mid !== student))
    else setSelectedStudents((prev) => !prev.find(el => el.mid === student.mid) ? [...prev, student] : prev.toSpliced(prev.indexOf(student), 1))
  }

  const renderLi = (data) => {
    const { fio, student, mid, year_liter } = data
    return (
      <tr>
        <td>{fio || student}</td>
      </tr>
    )
  }
  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Input
              label='№ приказа'
              name='string'
              value={values.string}
              // error={error('string')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='Дата'
              name='date'
              value={moment(values.date).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            {openEnrollModal &&
              <EnrollModal
                closeModal={closeEnroll}
                data={openEnrollModal}
                height={'430px'}
                handleChangeStudents={handleChangeStudents}
                selectedStudents={selectedStudents}
              />
            }
            <Button mode='white' onClick={openEnroll}>Добавить ученика</Button>
            {selectedStudents.length > 0 && <Table className={styles.tables}>
              <thead>
                <tr>
                  <th>ФИО</th>
                </tr>
              </thead>
              <tbody>
                {selectedStudents.map(renderLi)}
              </tbody>
            </Table>}
          </div>
          <div className={styles.inputsRow}>
            <Select
              label='Вид'
              name='string'
              value={values.string2}
              // error={error('rachid')}
              onChange={handleChange}
            // onBlur={handleBlur}
            >
              <option value=''>Не выбран</option>
              {/* {classes?.map(item => <option value={item.gid}>{item.name}</option>)} */}
            </Select>
          </div>
          <div className={styles.inputsRow}>
            <Select
              label='Кем поощерен / наказан'
              name='num'
              value={values.string3}
              // error={error('rachid')}
              onChange={handleChange}
            // onBlur={handleBlur}
            >
              <option value=''>Не выбран</option>
              {/* {classes?.map(item => <option value={item.gid}>{item.name}</option>)} */}
            </Select>
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Причина'
              name='string4'
              value={values.string4}
              // error={error('string4')}
              onChange={handleChange}
              style={{ width: '300px', height: '100px' }}
            />
          </div>
        </div>
      </div >

    </>
  )
}
